// extracted by mini-css-extract-plugin
export default {"AboutMePage":"AboutMe-Page_AboutMePage__pZxnm","Content_Part":"AboutMe-Page_Content_Part__xCGFL","paragraph":"AboutMe-Page_paragraph__HiRTl"};